<template>
  <div>

    <section v-if="view.content.sections.length" 
    v-for="(i, index) in view.content.sections" 
    :class="{ 
      'hero': true, 
      'skew': true, 
      'is-medium' : i.size == 'is-medium', 
      'is-large' : i.size == 'is-large', 
      'is-fullheight' : i.size == 'is-fullheight', 
      'is-white' : i.style == 'is-white', 
      'is-primary' : i.style == 'is-primary', 
      'is-secondary' : i.style == 'is-secondary'
    }"
    :key="index">
      <div class="hero-body" :style="((index == 0) && (!view.content.hasOwnProperty('pageSlider') || !view.content.pageSlider.length)) ? 'padding-top:0;' : ''">
        <div class="container" :class="{ 'is-fluid' : i.fullwidth }">
          <div class="columns is-multiline is-centered">
            <div class="column is-12 has-text-centered">
              <h2 class="is-size-3 is-size-4-mobile script has-text-left-mobile">{{ i.headline }}</h2>
              <h3 v-if="i.subtitle.length" class="is-size-5 is-size-6-mobile has-text-left-mobile">{{ i.subtitle }}</h3>
            </div> 
            <div
            v-for="(col, index) in i.columns"
            :class="{ 
              'column': true,
              'has-text-centered': true,
              'is-half-tablet is-one-quarter-desktop': i.columns.length==4
               }"
               :key="index">
              <figure v-if="col.image.path.length">
                <div class="img-circle" :style="'background-image: url(' + assetsBaseUrl + col.image.path + ');'">
                </div>
              </figure>
              <h2 v-if="col.headline.length" class="is-size-6 has-text-weight-bold has-text-left-mobile">{{ col.headline }}</h2>
              <p class="is-size-6 is-size-7-mobile has-text-left-mobile" style="white-space: pre-line;">{{ col.text }}</p>

              <template v-if="col.link.length">
              <a v-if="col.linkExternal" class="button is-rounded has-text-weight-bold is-primary margin-top" :href="col.link" target="_blank" v-html="col.linktext.length ? col.linktext : 'Erfahren Sie mehr'"></a>
              <router-link v-else class="button is-rounded has-text-weight-bold is-primary margin-top" :to="col.link" v-html="col.linktext.length ? col.linktext : 'Erfahren Sie mehr'"></router-link>
            </template>

            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: ['view'],
  computed: {
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    }
  },
  components: {
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Sections.vue